import type { Step } from "../script";

export const siteAudit: Step[] = [
  {
    kind: "msg",
    id: "msg-02c-a",
    tokens:
      "how we get ahead of drift: every merchant's site is scored automatically. t&c clarity, refund policy, cancel ease, product clarity, mcc alignment. poor scores predict higher fraud.",
    pauseAfter: 1200,
  },
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "merchant", merchantId: "MID-025" },
    pauseAfter: 1400,
  },
  {
    kind: "msg",
    id: "msg-02c-b",
    tokens:
      "corewellness caught my eye. site score 34 — bottom of its mcc. misaligned content, phone-only cancel, missing renewal clauses.",
    pauseAfter: 1200,
  },
  {
    kind: "msg",
    id: "msg-02c-c",
    tokens:
      "emailing ops with findings + 14-day window. preemptive 3ds @ 40% in parallel so we're not exposed.",
    pauseAfter: 900,
  },
  {
    kind: "act",
    id: "act-site-audit",
    title: "corewellness · site audit outreach + 3ds preemptive 40%",
    body: "email ops · 14-day window · 3ds @ 40% until site score > 60",
    receipt: "COREWELLNESS · site audit remediation · 3ds @ 40% · applied",
    actMs: 5800,
  },
];
